import { Grid, Stack, Tooltip } from '@mui/material';
import Icon from 'components/icons/Icon';
import { Button } from '@nps.today/component-library';
import DisabledIcon from 'components/util/Status/DisabledIcon';
import EnabledIcon from 'components/util/Status/EnabledIcon';
import { FunctionComponent } from 'react';
import useCustomDispatch from 'redux/dispatch';
import { resendUserInvite } from 'redux/slices/user';
import { RootState, useSelector } from 'redux/store';
import { useTranslator } from 'translation/useTranslator';

type EmailConfirmedProps = {
  userId: string;
  userEmail: string;
  emailConfirmed: boolean;
  center?: boolean;
};
const EmailConfirmed = ({
  userId,
  userEmail,
  emailConfirmed,
  center = true
}: EmailConfirmedProps) => {
  return (
    <Stack alignItems={center ? 'center' : ''} sx={{ width: 1, textAlign: 'center' }}>
      {emailConfirmed ? (
        <EnabledIcon tooltip="" />
      ) : (
        <>
          {center ? (
            <Grid container>
              <Grid size={4} />
              <Grid
                size={4}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <DisabledIcon tooltip="" />
              </Grid>
              <Grid size={4} style={{ display: 'flex', justifyContent: 'center' }}>
                <ResendInviteButton userId={userId} userEmail={userEmail} />
              </Grid>
            </Grid>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <DisabledIcon tooltip="" />
              <ResendInviteButton userId={userId} userEmail={userEmail} />
            </div>
          )}
        </>
      )}
    </Stack>
  );
};
interface ResendInviteButtonProps {
  userId: string;
  userEmail: string;
}

const ResendInviteButton: FunctionComponent<ResendInviteButtonProps> = ({ userId, userEmail }) => {
  const translator = useTranslator();
  const { loading } = useSelector((state: RootState) => state.user);
  const customDispatch = useCustomDispatch();
  return (
    <Tooltip title={translator.resendInvite()}>
      <div>
        <Button
          dataTestId="resend-invite"
          loading={loading?.[`userInvite${userId}`]}
          startIcon={<Icon type="resendsurvey" />}
          color="primary"
          onClick={async (event) => {
            event.stopPropagation();
            customDispatch({
              action: resendUserInvite,
              actionParameters: { userId: userId, userEmail: userEmail }
            });
          }}
        />
      </div>
    </Tooltip>
  );
};

export default EmailConfirmed;
